/* eslint-disable import/prefer-default-export */
import { sendGtmEvent } from "./definitions";

export const sendSocialClickTrackingEvent = (
  link: string,
  text: string | null,
  location?: string
) => {
  sendGtmEvent({
    event: "social_share_click",
    eventAction: `${location ?? getPageType()} Click`,
    eventLabel: text ?? "",
    eventCategory: link,
  });
};

const getPageType = () => {
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  if (pathParts.length === 0) return "";
  const subdir = pathParts[0];
  if (subdir === "article") {
    return "Article";
  }
  if (subdir === "guide") {
    return "Guide";
  }
  if (subdir?.includes("video")) {
    return "Video";
  }
  if (subdir === "blog") {
    return "Blog";
  }
  if (subdir === "careers") {
    return "Job";
  }
  return "Unknown";
};
